module.exports = __webpack_public_path__ + "img/ic_liucheng.92869c68.svg";